import { UseQueryResult, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiRequest } from '../util/util'

export const useCredits = ({
  projectId,
  userId,
}: {
  projectId: number
  userId: string
}): UseQueryResult<{
  projectOwnerCredits: number | null | undefined
  userCredits: number
  remainingChatbots: number
  maxChatbots: number
} | null> => {
  const queryClient = useQueryClient()
  return useQuery({
    queryKey: ['credits', { projectId }],
    queryFn: () => fetchCredits(projectId),
    enabled: !!projectId && !!userId && projectId !== -1,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['chatbots'])
      queryClient.invalidateQueries(['chatbot'])
    },
  })
}

export async function fetchCredits(projectId: number): Promise<{
  projectOwnerCredits: number | null | undefined
  userCredits: number
  remainingChatbots: number
  maxChatbots: number
} | null> {
  // make a request to api/credits
  const response = await apiRequest(`credits?projectId=${projectId}`)
  return {
    projectOwnerCredits: response.projectOwnerCredits,
    userCredits: response.userCredits,
    remainingChatbots: response.remainingChatbots,
    maxChatbots: response.maxChatbots,
  }
}
